import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import Menu from '@material-ui/core/Menu';
import LanguageIcon from '@material-ui/icons/Language';
import clsx from 'clsx';
import moment from 'moment';
import { getUser } from 'src/utils/Common';

function getNormalizedLanguage() {
  let language = localStorage.i18nextLng || 'en'; // Retrieve the language from localStorage or default to 'en'

  // Check if the language is 'zh-chs' (custom code for Simplified Chinese)
  if (language.toLowerCase() === 'zh-chs') {
    language = 'zh-CN';  // Replace 'zh-chs' with 'zh-CN'
  }

  // Return the language code in lower case format (to handle other cases as well)
  return language.toLocaleLowerCase();
}

const useStyles = makeStyles(theme => ({
  root: {}
}));

export const options = [
  { name: 'English', key: 'en' },
  { name: 'Afrikaans', key: 'af' },
  { name: 'العربية', key: 'ar' },
  { name: 'Azərbaycan türkcəsi', key: 'az' },
  { name: 'বাংলা', key: 'bn' },
  { name: '中文（繁體)-(Traditional Chinese - HK)', key: 'zh-CN' },
  { name: '中文（繁體)-(Traditional Chinese)', key: 'zh-TW' },
  { name: '中文（简体)-(Simplified Chinese)', key: 'zh-Chs' },
  { name: 'Hrvatski', key: 'hr' },
  { name: 'Čeština', key: 'cs' },
  { name: 'Dansk', key: 'da' },
  { name: 'Eesti', key: 'et' },
  { name: 'Suomi', key: 'fi' },
  { name: 'Français', key: 'fr' },
  { name: 'ქართული', key: 'ka' },
  { name: 'Deutsch', key: 'de' },
  { name: 'ελληνικά', key: 'el' },
  { name: 'עברית', key: 'iw' },
  { name: 'Magyar', key: 'hu' },
  { name: 'Bahasa Indonesia', key: 'id' },
  { name: 'Italiano', key: 'it' },
  { name: 'Қазақ', key: 'kk' },
  { name: 'Latviešu valoda', key: 'lv' },
  { name: 'Lietuvių', key: 'lt' },
  { name: 'Bahasa Melayu', key: 'my' },
  { name: 'Norsk', key: 'no' },
  { name: 'Polski', key: 'pl' },
  { name: 'Português', key: 'pt' },
  { name: 'Română', key: 'ro' },
  { name: 'русский', key: 'ru' },
  { name: 'Srpski Jezik', key: 'rs' },
  { name: 'Slovenčina', key: 'sk' },
  { name: 'Slovinský', key: 'sl' },
  { name: 'Español', key: 'es' },
  { name: 'Svenska', key: 'sv' },
  { name: 'Türkçe', key: 'tr' },
  { name: 'Українська', key: 'ua' },
  { name: 'اردو', key: 'ur' },
  { name: 'isiXhosa', key: 'xh' },
  { name: 'isiZulu', key: 'zu' },
  { name: 'Bosanski', key: 'bs' },
  { name: 'Tiếng Việt', key: 'vn' },
  { name: 'ไทย', key: 'th' },
  { name: 'Nederlands', key: 'nl' },
  { name: 'македонски', key: 'mk' },
  { name: 'shqip', key: 'sq' },
  { name: 'isiNdebele', key: 'nd'},
  { name: 'Sepedi (Northern Sotho)', key: 'nso'},
  { name: 'Sesotho (Southern Sotho)', key: 'st'},
  { name: 'Setswana (Tswana)', key: 'tn'},
  { name: 'siSwati (Swati/Swazi)', key: 'ss'},
  { name: 'Tshivenda (Venda)', key: 've'},
  { name: 'Xitsonga (Tsonga)', key: 'ts'},
  { name: 'Swahili', key: 'sw'}
];

const SelectLanguage = ({ className }) => {
  const classes = useStyles();
  const SessionUser = getUser();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { i18n } = useTranslation();
  const [selectedIndex, setSelectedIndex] = React.useState(
    options.findIndex(lang => lang.key === i18n.language)
  );

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    i18n.changeLanguage(options[index].key);
    localStorage.setItem('i18nextLng_selected', 1);
    localStorage.setItem('i18nextLng_normalized', getNormalizedLanguage());
    moment.locale(options[index].key);
    setAnchorEl(null);
  };

  useEffect(() => {
    var DefaultLang = SessionUser.TenantLangCode;
    if (localStorage.getItem('i18nextLng') !== undefined && localStorage.getItem('i18nextLng_selected') == '1') {
      DefaultLang = localStorage.getItem('i18nextLng');
    }
    setSelectedIndex(options.findIndex(lang => lang.key === DefaultLang));
    i18n.changeLanguage(DefaultLang);
    localStorage.setItem('i18nextLng_normalized', getNormalizedLanguage());
    moment.locale(DefaultLang);
    setAnchorEl(null);
  }, []);


  return (
    <div className={clsx(classes.root, className)}>
      <IconButton
        aria-label="language-select"
        className={classes.margin}
        color="inherit"
        onClick={event => setAnchorEl(event.currentTarget)}
      >
        <LanguageIcon />
      </IconButton>

      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {options.map((option, index) => (
          <MenuItem
            key={index}
            selected={index === selectedIndex}
            onClick={event => handleMenuItemClick(event, index)}
          >
            {option.name}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default SelectLanguage;
